module.exports = "https://static.wmbcdn.com/uniweb/images/b2b278da9249e434990107db5f6a4482.svg";